import { FormError } from '../../../../helpers/FormHelper';
import { ICookieConsentConfiguration } from '../../../../interfaces/CookieConsentConfiguration';
import { IGroupingRule } from '../../../../interfaces/GroupingRule';
import { ILoginConfiguration } from '../../../../interfaces/LoginConfiguration';
import { IProperty } from '../../../../interfaces/Property';
import { IScheduledJobConfiguration } from '../../../../interfaces/ScheduledJobConfiguration';
import { IUrlSeed } from '../../../../interfaces/UrlSeed';
import { IAllowedDeniedFilter } from '../../../../interfaces/UrlSetDiscoveryConfiguration';
import { SETTINGS_SECTION_TYPES } from '../../../../types/SettingsSectionTypes';
import { URL_SET_SOURCES } from '../../../../types/UrlSetSources';
import { ACTION_TYPES, PropertySettingsAction } from '../action-types';

export const initFromServer = (
	property: IProperty,
	sourceMode: URL_SET_SOURCES
): PropertySettingsAction => ({
	type: ACTION_TYPES.INIT_FROM_SERVER,
	payload: { property, sourceMode }
});

export const initNew = (property: IProperty): PropertySettingsAction => ({
	type: ACTION_TYPES.INIT_NEW,
	payload: { property }
});

export const setName = (name: string): PropertySettingsAction => ({
	type: ACTION_TYPES.SET_NAME,
	payload: name
});

export const setSourceMode = (sourceMode: URL_SET_SOURCES): PropertySettingsAction => ({
	type: ACTION_TYPES.SET_SOURCE_MODE,
	payload: sourceMode
});

export const setScheduling = (
	config: IScheduledJobConfiguration | undefined
): PropertySettingsAction => ({
	type: ACTION_TYPES.SET_SCHEDULING,
	payload: config
});

export const setLogin = (
	scanLogin: ILoginConfiguration | null,
	urlSetLogin: ILoginConfiguration | null,
	cookieConsent: ICookieConsentConfiguration | null
): PropertySettingsAction => ({
	type: ACTION_TYPES.SET_LOGIN,
	payload: { scanLogin, urlSetLogin, cookieConsent }
});

export const setSeeds = (seeds?: IUrlSeed[], urls?: string[]): PropertySettingsAction => ({
	type: ACTION_TYPES.SET_SEEDS,
	payload: { seeds, urls }
});

export const setScope = (
	languageFilter: IAllowedDeniedFilter,
	urlPatternFilter: IAllowedDeniedFilter,
	domainFilter: IAllowedDeniedFilter
): PropertySettingsAction => ({
	type: ACTION_TYPES.SET_SCOPE,
	payload: { languageFilter, urlPatternFilter, domainFilter }
});

export const setGrouping = (groupingRules: IGroupingRule[]): PropertySettingsAction => ({
	type: ACTION_TYPES.SET_GROUPING,
	payload: groupingRules
});

export const setMaxPages = (maxPagesCount: number): PropertySettingsAction => ({
	type: ACTION_TYPES.SET_MAX_PAGES,
	payload: maxPagesCount
});

export const setFileType = (allowedContentTypes: string[]): PropertySettingsAction => ({
	type: ACTION_TYPES.SET_FILE_TYPE,
	payload: allowedContentTypes
});

export const setErrors = (errors: FormError[]): PropertySettingsAction => ({
	type: ACTION_TYPES.SET_ERRORS,
	payload: errors
});

export const clearSectionError = (sectionId: SETTINGS_SECTION_TYPES): PropertySettingsAction => ({
	type: ACTION_TYPES.CLEAR_SECTION_ERROR,
	payload: sectionId
});

export const setLoading = (isLoading: boolean): PropertySettingsAction => ({
	type: ACTION_TYPES.SET_LOADING,
	payload: isLoading
});

export const setSaving = (isSaving: boolean): PropertySettingsAction => ({
	type: ACTION_TYPES.SET_SAVING,
	payload: isSaving
});

export const markSaved = (): PropertySettingsAction => ({
	type: ACTION_TYPES.MARK_SAVED
});

export const resetDraft = (): PropertySettingsAction => ({
	type: ACTION_TYPES.RESET_DRAFT
});

export const applySourceConversion = (property: IProperty): PropertySettingsAction => ({
	type: ACTION_TYPES.APPLY_SOURCE_CONVERSION,
	payload: property
});

export const setDraft = (property: IProperty): PropertySettingsAction => ({
	type: ACTION_TYPES.SET_DRAFT,
	payload: property
});
